export default __webpack_public_path__ + "static/media/gasag_background_s2.e9a8ca95.jpg";